import './styles.css';
import React, { FC } from 'react';
import IC_SHORTCUT from 'assets/icons/ic_shortcut.svg';

interface IBidCard {
  avatar?: string;
  username: string;
  createdAt: Date;
  price: number;
  title: string;
}



function convertDateFormat(dateStr: any) {
  const dateObj = new Date(dateStr);

  const month = dateObj.toLocaleDateString('en-US', { month: 'short' });
  const day = dateObj.toLocaleDateString('en-US', { day: 'numeric' });
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const adjustedHours = hours % 12 || 12;
  const formattedStr = `${month} ${day} at  ${adjustedHours}:${minutes
    .toString()
    .padStart(2, '0')} ${suffix}`;
  return formattedStr;
}





const BidCard: FC<IBidCard> = ({
  avatar,
  username,
  createdAt,
  price,
  title,
}) => {
  const defaultAvatar = require('assets/Profile/buku_default_avatar.png');
  return (
    <div className="listed-card">
      <div>
        <div className="listed-by-main-div">
          <div className="listed-by-user-info-div">
            <label className="listed-by-label">{title}</label>
            <div className="user-info">
              <img
                src={avatar || defaultAvatar}
                alt="usr"
                className="user-image"
              />
              <label>@{username}</label>
            </div>
            <div className="value-label">{price} ETH</div>
          </div>
          <div className="listed-date-div">
            {convertDateFormat(createdAt)}
          </div>
        </div>
      </div>
      <img src={IC_SHORTCUT} className="icon-shortcut" alt="ic-shortcut" />{' '}
    </div>
  );
};

export default BidCard;
